import { Box, Button, Checkbox, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { MdOutlineCheck } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router-dom'
import { appApi } from '../../../../services/appApi'
import { isAuth } from '../../../../services/token'
import { iPerfilColaboradorAssinante } from '../VisualizacaoSolicitacao'

interface iPropsModalAssinarDocumento{
  isOpen: boolean
  onClose: () => void
  setDadosAssinante: React.Dispatch<React.SetStateAction<Partial<iPerfilColaboradorAssinante> | undefined>>
  dadosAssinante: Partial<iPerfilColaboradorAssinante> | undefined
}

export const ModalAssinarDocumento: React.FC<iPropsModalAssinarDocumento> = ({ isOpen, onClose, setDadosAssinante, dadosAssinante }) => {
  const nav = useNavigate()

  const { documentoId } = useParams()
  const codigo = localStorage.getItem(`codigo-assinatura-cargosESalarios-${documentoId ?? ''}`)
  const toast = useToast()
  const [termosAceitos, setTermosAceitos] = useState(false)

  function getColaboador(): void {
    // O codigo e quem de fato vai assinar (handleAssinarDocumento so manda documentoId+codigo):
    // se ele existir, prioriza sobre uma sessao logada de outra pessoa no mesmo navegador
    if (codigo) {
      const request = {
        id: documentoId,
        codigo: codigo
      }
      appApi.post('api/Assinatura/GetAssinaturaByIdAndCode', request)
        .then(response => {
          setDadosAssinante({
            nome: response.data.nomeAssinante,
            email: response.data.emailAssinante,
            assinado: response.data.assinado
          })
        })
        .catch(err => console.log(err))
    } else if (isAuth()) {
      appApi.get('Colaborador/Perfil')
        .then(response => { setDadosAssinante(response.data) })
        .catch(err => console.log(err))
    }
  }

  function handleAssinarDocumento(): void {
    onClose()
    const body = {
      DocumentoId: documentoId,
      Codigo: codigo
    }
    appApi.post('api/Assinatura/assinar', body)
      .then((res) => {
        if (res.data.sucesso) {
          toast({
            position: 'top',
            title: 'Documento assinado',
            status: 'success',
            duration: 3000
          })

          nav(`/Descritivo/Assinatura/LinhaDoTempo/${documentoId}/AssinaturaConfirmacao`)
        }
      })
      .catch((error) => {
        console.error('Erro ao assinar documento:', error)
        toast({
          position: 'top',
          title: 'Algo deu errado',
          status: 'error',
          duration: 3000
        })
      })
  }

  useEffect(() => (
    getColaboador()
  ), [])
  return (
        <>
        <Modal isOpen={isOpen} onClose={onClose} isCentered autoFocus={false}>
            <ModalOverlay />
            <ModalContent maxW={'900px'}>
                <ModalHeader fontWeight={'bold'} color={'blue.400'}>Assinatura Eletrônica</ModalHeader>
                <ModalCloseButton color={'gray.500'} bgColor={'white'} />

                 <ModalBody display={'flex'} justifyContent={'center'}>
                    <Flex flexDirection={'column'}>
                        <Box bgColor={'blue.50'} display={'flex'} flexDirection={'row'} gap={'4rem'} borderRadius={'.40rem'} border={'2px solid'} borderColor={'blue.300'} w={'800px'} p={'1rem '} justifyContent={'space-between'}>
                            <Box>
                                <Text color={'gray.500'} fontSize={'small'}>Nome assinante</Text>
                                <Text as={'h3'} fontWeight={'medium'}>{dadosAssinante?.nome}</Text>
                            </Box>
                            <Box>
                                <Text color={'gray.500'} fontSize={'small'}>E-mail assinante</Text>
                                <Text as={'h3'} fontWeight={'medium'}>{dadosAssinante?.email}</Text>
                            </Box>
                        </Box>

                        <Box mt={'1.5rem'} fontSize={'large'}>
                            <Text>Você está prestes a assinar digitalmente o termo de alteração contratual.</Text>
                            <Text>Esta ação tem validade jurídica interna</Text>
                        </Box>

                        <Checkbox mt={'1.5rem'} size={'lg'} isChecked={termosAceitos} onChange={(e) => setTermosAceitos(e.target.checked)}>
                            <Text fontWeight={'medium'} fontSize={'md'}>Estou de acordo com os termos descritos no documento e confirmo a Veracidade dos dados.</Text>
                        </Checkbox>
                        {!termosAceitos && (
                            <Text color={'red.500'} fontSize={'sm'} mt={'.5rem'}>É necessário concordar com os termos para prosseguir com a assinatura.</Text>
                        )}
                    </Flex>
                </ModalBody>

                <ModalFooter>
                    <Button bgColor={'gray.500'} p={'1.5rem'} mr={3} onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button onClick={handleAssinarDocumento} isDisabled={!termosAceitos} bgColor={'green.400'} p={'1.5rem'} leftIcon={<MdOutlineCheck size={20}/>}>Confirmar e assinar</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
        </>
  )
}
